<template>
	<div class="upgradeRecord">
		<div class="itemTitleBox disStart">
			<span class="title">远程升级记录</span>
		</div>
		<div class="BtnBox disBetween">
			<div class="searchBox disBetween">
				<div class="disBetween searchLeft">
					<div class="myinputBox myinputBox5">
						<el-date-picker v-model="searchObj.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
							placeholder="开始时间">
						</el-date-picker>
					</div>
					<div class="myinputBox myinputBox5">
						<el-date-picker v-model="searchObj.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss"
							placeholder="结束时间">
						</el-date-picker>
					</div>
					<el-button type="success" @click="toSearch">查询</el-button>
				</div>
			</div>

		</div>
		<div class="listBox">
			<div style="height: 100%;width: 100%;" v-loading="loading">
				<div class="content myTable">
					<el-table :data="tableData" stripe style="width: 100%">
						<el-table-column type="index" label="序号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="startTime" label="升级时间">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="loginName" label="操作人">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="versionName" label="升级版本">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="equipmentNum" label="升级设备数量">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="status" label="状态">
							<template slot-scope="scope">
								<span>{{scope.row.status==1?'进行中':scope.row.status==2?'结束':scope.row.status==3?'暂停':''}}</span>
								</span>
							</template>
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="totalTime" label="用时">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="abnormalNum" label="异常数量">
						</el-table-column>
						<el-table-column label="操作" width="50">
							<template slot-scope="scope">
								<div class="pupBox">
									<span class="hoverClass2" @click.stop="itemClick(scope.row)">详情</span>
								</div>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination  mypagination">
					<el-pagination background small :page-size="PageInfo.pagesize" :current-page="PageInfo.pagenum"
						:total="PageInfo.total" :pager-count="5" prev-text="上一页" next-text="下一页"
						layout="total, prev, pager, next,jumper" ref="pagination" @current-change="handleCurrentChange">
					</el-pagination>
				</div>
			</div>
		</div>
		<el-dialog title="升级详情" center class="mydialog" :close-on-click-modal="NOfalse" :visible.sync="dialogOperation2"
			width="90%">
			<div class="dialogBox dialogBox2">
				<div class="diaItem disStart">
					<div class="myinputBox">
						<el-input clearable v-model="searchObj2.communityName" placeholder="请输入社区名称">
						</el-input>
					</div>
					<div class="myinputBox" v-if="!($serviceProviderId)">
						<el-select clearable v-model="searchObj2.serviceProviderId" slot="prepend" placeholder="请选择运营商">
							<el-option v-for="(item,inx) in restaurants" :key="inx" :label="item.serviceProviderName"
								:value="item.serviceProviderId"></el-option>
						</el-select>
					</div>
					<div class="myinputBox">
						<el-cascader clearable ref="cascader1" placeholder="请选择地区"
							:props="{ value: 'areaCode',label: 'areaName',children: 'childList'}" v-model="areaValue"
							:options="areaList" @change="handleChange($event,1)">
						</el-cascader>
					</div>
					<div class="myinputBox">
						<el-select clearable v-model="searchObj2.status" slot="prepend" placeholder="升级结果">
							<el-option v-for="(item,inx) in updateList" :key="inx" :label="item.text"
								:value="item.value"></el-option>
						</el-select>
					</div>
					<el-button type="success" @click="getoperationData">查询</el-button>
				</div>
				<div class="myTable myTable2" v-loading="loading2">
					<el-table :data="operationData" style="width: 100%">
						<el-table-column type="index" label="序号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="equipmentNo" label="设备编号">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="versionName" label="当前升级版本">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="equipmentNo" label="设备名称">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="communityName" label="所属社区">
						</el-table-column>
						<el-table-column prop="serviceProviderName" label="所属运营商">
						</el-table-column>
						<el-table-column show-overflow-tooltip prop="areaCode" label="地区" width="150">
							<template slot-scope="scope">
								{{scope.row.provinceName}}{{scope.row.cityName}}{{scope.row.areaName}}
							</template>
						</el-table-column>
						<el-table-column prop="updateStatus" label="升级结果">
							<template slot-scope="scope">
								<span>{{getName(scope.row.updateStatus,updateList)}}</span>
							</template>
						</el-table-column>

					</el-table>
				</div>
				<div class="pagination mypagination  mypagination2">
					<el-pagination background small :page-size="OperationInfo.pagesize"
						:current-page="OperationInfo.pagenum" :total="OperationInfo.total" :pager-count="5"
						prev-text="上一页" next-text="下一页" layout="total, prev, pager, next,jumper" ref="pagination"
						@current-change="handleCurrentChange2($event,2)">
					</el-pagination>
				</div>
				<div slot="footer" class="dialog-footer diabtnBox disAround">
					<el-button type="primary" @click="dialogOperation2= false">确 定</el-button>
				</div>
			</div>
		</el-dialog>
	</div>

</template>

<script type="text/javascript">
	export default {
		name: "upgradeRecord",
		components: {},
		data() {
			return {
				NOfalse: false,
				dialogOperation2: false,
				PageInfo: {
					pagesize: 7,
					pagenum: 1,
					total: 0
				},
				tableData: [],
				loading: false,
				searchObj: {
					pageNo: 1, //当前页
					pageSize: 7, //当前页个数
					startTime: "", //开始时间（yyyy-MM-dd）
					endTime: "" //结束时间（yyyy-MM-dd）
				},
				searchObj2: {
					pageSize: 7,
					pageNo: 1,
					provinceCode: "",
					communityName: "",
					updateStatus: "",
					cityCode: "",
					areaCode: "",
					serviceProviderId: "",
					communityId: "",
					status: "",
				},
				loading2: false,
				operationData: [],
				OperationInfo: {
					pagesize: 7,
					pagenum: 1,
					total: 0
				},
				restaurants: [],
				areaValue: "",
				areaList: [],
				updateList: [{
					text: "初始状态",
					value: 0
				}, {
					text: "下发指令",
					value: 1
				}, {
					text: "升级中",
					value: 2
				}, {
					text: "升级成功",
					value: 3
				}, {
					text: "升级失败",
					value: 4
				}]
			}
		},
		mounted() {
			this.selectParamConfigByCode()
			this.getAreaList()
			this.getData()
		},
		methods: {
			getName(val, arr) {
				
					let obj = arr.find((item) => {
						return val == item.value
					})
					return obj.text
			},
			// 省市区数据
			getAreaList() {
				this.$api.listAllAreaInfo().then((res) => {

					if (res.returnCode == 200) {
						this.$set(this, "areaList", res.obj)
					}
				})
			},
			selectParamConfigByCode() {
				this.$api.listAllProvider({}).then((res) => {
					if (res.returnCode == 200) {
						this.$set(this, "restaurants", res.obj || [])
					}
				})
			},
			toSearch() {
				this.searchObj.pageNo = 1
				this.PageInfo.pagenum = 1
				this.$nextTick(() => {
					this.getData()
				})
			},
			getoperationData() {
				this.searchObj2.pageNo = 1
				this.OperationInfo.pagenum = 1
				this.$nextTick(() => {
					this.getDalogList()
				})
			},
			getData() {
				this.loading = true
				let obj = {
					pageNo: this.searchObj.pageNo, //当前页
					pageSize: this.searchObj.pageSize, //当前页个数
					startTime: this.searchObj.startTime, //开始时间
					endTime: this.searchObj.endTime //结束时间
				}
				this.$api.listUpdateRecord(obj).then((res) => {
					if (res.returnCode == 200) {
						this.loading = false
						this.$set(this, "tableData", res.obj.list || [])
						this.$set(this.PageInfo, "total", res.obj.total || 0)
					}
				})
			},
			// 选择分页
			handleCurrentChange(val) {
				this.searchObj.pageNo = val
				this.getData()
			},
			// 选择分页
			handleCurrentChange2(val) {
				this.searchObj2.pageNo = val
				this.$nextTick(() => {
					this.getDalogList()
				})
			},
			itemClick(obj) {
				this.$set(this, "searchObj2", {
					pageSize: 7,
					pageNo: 1,
					provinceCode: "",
					communityName: "",
					cityCode: "",
					areaCode: "",
					serviceProviderId: "",
					updateRecordId: obj.updateRecordId,
					communityId: "",
					status: "",
				})
				this.getDalogList()
				this.dialogOperation2 = true

			},
			getDalogList() {
				this.loading2=true
				this.$api.listUpdateEquipmentByUpdateRecordId(this.searchObj2).then((res) => {
					if (res.returnCode == 200) {
						this.loading2=false
						this.$set(this, "operationData", res.obj.list)
						this.$set(this.OperationInfo, "total", res.obj.total || 0)
					}
				})
			},
			// 省市区联动
			handleChange(value, n) {
				let nodesInfo = this.$refs['cascader' + n].getCheckedNodes()
				if (nodesInfo.length > 0) {
					this.$set(this.searchObj2, "provinceCode", nodesInfo[0].path[0] || "")
					this.$set(this.searchObj2, "cityCode", nodesInfo[0].path[1] || "")
					this.$set(this.searchObj2, "areaCode", nodesInfo[0].path[2] || "")
				} else {
					this.$set(this.searchObj2, "provinceCode", "")
					this.$set(this.searchObj2, "cityCode", "")
					this.$set(this.searchObj2, "areaCode", "")
				}

			},
		}
	}
</script>

<style lang="scss" scoped>
	@import "./upgradeRecord.scss"
</style>